module.exports = __webpack_public_path__ + "static/media/post-warning-icon.4a1866da.svg";